import styled from 'styled-components';
import { theme, palette } from 'styled-tools';
import { BsPlus } from 'react-icons/bs';
import Card from '../Card';

const S = {};

S.Card = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 125px;
  background-color: ${palette('primary')};
  border-color: ${palette('primaryHover')};
  font-size: ${theme('fontSize.sm')};
  font-weight: ${theme('fontWeight.bold')};
  margin-bottom: ${theme('spacing.md')};
  color: ${palette('primaryHighlight')};

  &:hover {
    background-color: ${palette('primaryHover')};
  }

  ${theme('components.AddCard')}
`;

S.AddIcon = styled(BsPlus)`
  width: 34px;
  height: 34px;
  margin-bottom: ${theme('spacing.sm')};
`;

S.Link = styled.a`
  display: block;
  text-align: center;
  user-select: none;
  color: ${palette('primaryHighlight')};
`;

export default S;
